import React, { useState } from "react";
import styled from "styled-components";
import { useFarcaster } from "../../contexts/FarcasterContext";
import { APP_BASE_URL } from "../../config";

const Btn = styled.button<{ variant?: "primary" | "small" }>`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: linear-gradient(135deg, #7945ff, #5c2dd5);
  border: 2px solid var(--color-black);
  box-shadow: ${({ variant }) =>
    variant === "small"
      ? "0 0.3rem 0 var(--color-black)"
      : "0 0.6rem 0 var(--color-black)"};
  border-radius: ${({ variant }) =>
    variant === "small" ? "0.8rem" : "1.2rem"};
  padding: ${({ variant }) =>
    variant === "small" ? "0.5rem 1rem" : "0.9rem 1.8rem"};
  color: var(--color-white);
  font-size: ${({ variant }) => (variant === "small" ? "1.3rem" : "1.5rem")};
  font-family: inherit;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    filter: brightness(1.1);
    box-shadow: ${({ variant }) =>
      variant === "small"
        ? "0 0.3rem 0 var(--color-dark-purple)"
        : "0 0.6rem 0 var(--color-dark-purple)"};
  }
  &:active {
    transform: translateY(2px);
    box-shadow: 0 2px 0 var(--color-dark-purple);
  }
`;

const Farcaster = styled.span`
  font-size: 1.4em;
`;

interface Props {
  roomId: string;
  hostName?: string;
  variant?: "primary" | "small";
}

const ShareInviteBtn: React.FC<Props> = ({
  roomId,
  hostName,
  variant = "primary",
}) => {
  const { composeCast } = useFarcaster();
  const [shared, setShared] = useState(false);

  const handleShare = async () => {
    const inviteUrl = `${APP_BASE_URL}/share/invite/${roomId}`;
    const text = hostName
      ? `${hostName} challenges you to Connect Four! 🟡🔴 Join the game →`
      : `Join my Connect Four game! 🟡🔴`;

    await composeCast(text, inviteUrl);
    setShared(true);
    setTimeout(() => setShared(false), 3000);
  };

  return (
    <Btn variant={variant} onClick={handleShare}>
      <Farcaster>⬡</Farcaster>
      {shared ? "✓ Shared!" : "Share Invite"}
    </Btn>
  );
};

export default ShareInviteBtn;
